const intlSupported = window.Intl && typeof window.Intl === "object";

export default () => ({
  metadata: intlSupported
    ? btoa(Intl.DateTimeFormat().resolvedOptions().timeZone)
    : null,
  trigger: false,
});
